<template>
  <div>
    <div id="graphContainer" class="graph-container"></div>

    <side-bar :pouTempId="pouTempId"></side-bar>

    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          <span class="headline">{{ dialogTitle }}</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row v-if="editedObj.elementType === 'powerRail'">
              <v-col cols="6">
                <v-text-field
                  label="Pin number"
                  type="number"
                  v-model.number="editedObj.pinNumber"
                ></v-text-field>
              </v-col>

              <v-col cols="6">
                <v-select
                  label="Type"
                  :items="powerRailTypes"
                  v-model="editedObj.type"
                ></v-select>
              </v-col>
            </v-row>

            <v-row v-if="editedObj.elementType === 'contact'">
              <v-col cols="6">
                <v-select
                  label="Modifier"
                  :items="contactModifiers"
                  v-model="editedObj.modifier"
                ></v-select>
              </v-col>

              <v-col cols="6">
                <v-text-field
                  label="Variable"
                  v-model="editedObj.variable"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row v-if="editedObj.elementType === 'coil'">
              <v-col cols="6">
                <v-select
                  label="Modifier"
                  :items="coilModifiers"
                  v-model="editedObj.modifier"
                ></v-select>
              </v-col>

              <v-col cols="6">
                <v-text-field
                  label="Variable"
                  v-model="editedObj.variable"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row
              v-if="['step', 'initialStep'].includes(editedObj.elementType)"
            >
              <v-col cols="6">
                <v-text-field
                  label="Name"
                  v-model="editedObj.name"
                ></v-text-field>
              </v-col>

              <v-col cols="6">
                <v-select
                  multiple
                  label="Connectors"
                  :items="stepConnectors"
                  v-model="editedObj.connectors"
                ></v-select>
              </v-col>
            </v-row>

            <v-row v-if="editedObj.elementType === 'transition'">
              <v-col cols="12">
                <v-radio-group v-model="editedObj.type">
                  <v-radio label="Reference" value="reference"></v-radio>

                  <v-radio label="Inline" value="inline"></v-radio>

                  <v-radio label="Connection" value="connection"></v-radio>
                </v-radio-group>
              </v-col>

              <v-col cols="6" v-if="editedObj.type === 'reference'">
                <v-select
                  label="Reference"
                  v-model="editedObj.reference"
                ></v-select>
              </v-col>

              <v-col cols="6" v-if="editedObj.type === 'inline'">
                <v-text-field
                  label="Inline"
                  v-model="editedObj.inline"
                ></v-text-field>
              </v-col>

              <v-col cols="6">
                <v-text-field
                  label="Priority"
                  type="number"
                  v-model.number="editedObj.priority"
                ></v-text-field>
              </v-col>

              <!-- <v-col cols="6">
                <v-select label="Type" :items="transitionTypes" v-model="editedObj.type"></v-select>
              </v-col>-->
            </v-row>

            <v-row v-if="editedObj.elementType === 'jump'">
              <v-col cols="6">
                <v-select
                  label="Target"
                  v-model="editedObj.target"
                  :items="steps"
                ></v-select>
              </v-col>
            </v-row>

            <v-row v-if="editedObj.elementType === 'divergence'">
              <v-col cols="6">
                <v-select
                  label="Type"
                  v-model="editedObj.type"
                  :items="divergenceTypes"
                ></v-select>
              </v-col>

              <v-col cols="6">
                <v-text-field
                  label="Number of sequences"
                  type="number"
                  v-model.number="editedObj.numOfSequences"
                ></v-text-field>
              </v-col>

              <v-col cols="6">
                <v-text-field
                  label="Offset"
                  type="number"
                  v-model.number="editedObj.portPosition"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row v-if="editedObj.elementType === 'action'">
              <v-data-table
                :headers="actionHeaders"
                :items="editedObj.actions"
                class="elevation-1"
              >
                <template v-slot:top>
                  <v-toolbar flat color="white">
                    <v-toolbar-title>Actions</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-dialog v-model="actionDialog" max-width="500px">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          class="mb-2"
                          v-bind="attrs"
                          v-on="on"
                          @click="addAction"
                          >Add Action</v-btn
                        >
                      </template>
                      <v-card>
                        <v-card-title
                          class="headline grey lighten-2"
                          primary-title
                        >
                          <span class="headline">
                            {{ actionFormTitle }}
                          </span>
                        </v-card-title>

                        <v-card-text>
                          <v-container>
                            <v-row>
                              <v-col cols="6">
                                <v-select
                                  :items="qualifiers"
                                  label="Qualifier"
                                  v-model="editedAction.qualifier"
                                ></v-select>
                              </v-col>

                              <v-col
                                cols="6"
                                v-if="
                                  !['N', 'R', 'S', 'P', 'P0', 'P1'].includes(
                                    editedAction.qualifier
                                  )
                                "
                              >
                                <v-text-field
                                  label="Duration"
                                  v-model="editedAction.duration"
                                ></v-text-field>
                              </v-col>

                              <v-col cols="6">
                                <v-select
                                  :items="actionTypes"
                                  label="Type"
                                  v-model="editedAction.type"
                                ></v-select>
                              </v-col>

                              <v-col
                                cols="6"
                                v-if="editedAction.type === 'variable'"
                              >
                                <v-select
                                  :items="varNames"
                                  label="Value"
                                  v-model="editedAction.value"
                                ></v-select>
                              </v-col>

                              <v-col
                                cols="6"
                                v-if="editedAction.type === 'inline'"
                              >
                                <v-text-field
                                  label="Value"
                                  v-model="editedAction.value"
                                ></v-text-field>
                              </v-col>

                              <v-col cols="6">
                                <v-select
                                  label="Indicator"
                                  v-model="editedAction.indicator"
                                ></v-select>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card-text>

                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="blue darken-1"
                            text
                            @click="resetActionDialog()"
                            >Cancel</v-btn
                          >
                          <v-btn color="blue darken-1" text @click="saveAction"
                            >Save</v-btn
                          >
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-toolbar>
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-icon small class="mr-2" @click="editAction(item)"
                    >mdi-pencil</v-icon
                  >
                  <v-icon small @click="deleteAction(item)">mdi-delete</v-icon>
                </template>
              </v-data-table>
            </v-row>

            <v-row v-if="editedObj.elementType === 'comment'">
              <v-col cols="12">
                <v-textarea
                  label="Comment"
                  v-model="editedObj.value"
                ></v-textarea>
              </v-col>
            </v-row>

            <v-row v-if="editedObj.elementType === 'connection'">
              <v-col cols="6">
                <v-select
                  label="Type"
                  :items="connectionTypes"
                  v-model="editedObj.type"
                ></v-select>
              </v-col>

              <v-col cols="6">
                <v-text-field
                  label="Name"
                  v-model="editedObj.name"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row
              v-if="
                [
                  'standardFunctionBlockPou',
                  'additionalFunctionBlockPou',
                ].includes(editedObj.elementType)
              "
            >
              <v-col cols="6">
                <v-text-field
                  label="Name"
                  v-model="editedObj.variableName"
                ></v-text-field>
              </v-col>

              <v-col cols="6">
                <v-text-field
                  type="number"
                  label="Execution Order"
                  v-model.number="editedObj.executionOrder"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row
              v-if="
                [
                  'typeConversionPou',
                  'numericalPou',
                  'arithmeticPou',
                  'timePou',
                  'bitShiftPou',
                  'bitWisePou',
                  'selectionPou',
                  'comparisionPou',
                  'characterStringPou',
                ].includes(editedObj.elementType)
              "
            >
              <v-col cols="6">
                <v-text-field
                  type="number"
                  label="Execution Order"
                  v-model.number="editedObj.executionOrder"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row v-if="editedObj.elementType === 'userDefinedPou'">
              <v-col cols="6">
                <v-text-field
                  type="number"
                  label="Execution Order"
                  v-model.number="editedObj.executionOrder"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false"
            >Cancel</v-btn
          >
          <v-btn color="primary" text type="submit" @click="saveCell"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
const stringify = require("json-stringify-safe");
const { create } = require("xmlbuilder2");
const convert = require("xml-js");

import {
  assign,
  map,
  filter,
  find,
  some,
  values,
  flatten,
  isNil,
  findIndex,
} from "lodash";

import ldElements from "./ldElements.json";
import sfcElements from "./sfcElements.json";
import commonElements from "./commonElements.json";
import SideBar from "./SideBar";
import images from "./images";
import graph from "src/mixins/graph";
import uuid from "src/mixins/uuid";

export default {
  name: "SFCGraph",
  props: ["pouTempId"],
  components: { SideBar },
  mixins: [graph, uuid],
  data() {
    return {
      name: "SFC",

      steps: [],

      stepConnectors: [
        { text: "Input", value: "input" },
        { text: "Action", value: "action" },
        { text: "Output", value: "output" },
      ],
      transitionTypes: [
        { text: "Reference", value: "reference" },
        { text: "Inline", value: "inline" },
        { text: "Connection", value: "connection" },
      ],
      divergenceTypes: [
        { text: "Selection Divergence", value: "selectionDivergence" },
        { text: "Selection Convergence", value: "selectionConvergence" },
        { text: "Simultaneous Divergence", value: "simultaneousDivergence" },
        { text: "Simultaneous Convergence", value: "simultaneousConvergence" },
      ],

      qualifiers: ["N", "R", "S", "L", "D", "P", "P0", "P1", "SD", "DS", "SL"],
      actionTypes: [
        { text: "Action", value: "action" },
        { text: "Variable", value: "variable" },
        { text: "Inline", value: "inline" },
      ],
      actionHeaders: [
        { text: "Qualifier", sortable: false, value: "qualifier" },
        { text: "Duration", sortable: false, value: "duration" },
        { text: "Type", sortable: false, value: "type" },
        { text: "Value", sortable: false, value: "value" },
        { text: "Indicator", sortable: false, value: "indicator" },
        { text: "", sortable: false, value: "actions" },
      ],
      actionDialog: false,
      editedAction: {},
    };
  },
  computed: {
    vars() {
      return find(this.$store.state.pous, { tempId: this.pouTempId }).variables;
    },
    varNames() {
      return map(
        find(this.$store.state.pous, { tempId: this.pouTempId }).variables,
        "name"
      );
    },
    pous() {
      return this.$store.state.pous;
    },
    pou() {
      return find(this.$store.state.pous, { tempId: this.pouTempId });
    },
    actionFormTitle() {
      return "edit";
    },
  },
  methods: {
    renderTransitions(elements, oldIdsToNewIds, connections) {
      const transitionElements = filter(elements, { name: "transition" });
      for (const transitionElement of transitionElements) {
        const positionElement = find(transitionElement.elements, {
          name: "position",
        });

        const conditionElement = find(transitionElement.elements, {
          name: "condition",
        });

        let type;
        let inline;
        let reference;

        const referenceConditionElement = find(conditionElement.elements, {
          name: "reference",
        });
        const inlineConditionElement = find(conditionElement.elements, {
          name: "inline",
        });

        if (referenceConditionElement) {
          type = "reference";
          reference = "";
        } else if (inlineConditionElement) {
          const stElement = find(inlineConditionElement.elements, {
            name: "ST",
          });
          const pElement = find(stElement.elements, { name: "xhtml:p" });
          type = "inline";
          inline = pElement.elements[0].cdata;
        }

        const cell = this.graph.insertVertex(
          this.parent,
          null,
          JSON.stringify({
            elementType: "transition",
            name: "Transition",
            type,
            inline,
            reference,
            priority: +transitionElement.attributes.priority,
          }),
          +positionElement.attributes.x,
          +positionElement.attributes.y,
          +transitionElement.attributes.width,
          +transitionElement.attributes.height,
          "shape=transition"
        );
        cell.setConnectable(false);

        this.addPriorityToTransition(
          cell,
          +transitionElement.attributes.priority
        );
        this.addLabelToTransition(cell, reference || inline);

        oldIdsToNewIds[transitionElement.attributes.localId] = cell.id;

        const { inPort } = this.addPortToTransition(cell);

        const connectionPointInElement = find(transitionElement.elements, {
          name: "connectionPointIn",
        });
        if (connectionPointInElement) {
          const connectionElement = find(connectionPointInElement.elements, {
            name: "connection",
          });
          if (connectionElement?.attributes?.refLocalId) {
            connections.push({
              sourceId: connectionElement.attributes.refLocalId,

              targetPortNewId: inPort.id,

              sourcePortName: connectionElement.attributes.formalParameter,
            });
          }
        }
      }
    },

    renderJump(sfcElement, x, y) {
      const cell = this.graph.insertVertex(
        this.parent,
        null,
        JSON.stringify(sfcElement),
        x,
        y,
        20,
        20,
        "shape=jump"
      );
      cell.setConnectable(false);
      this.addPortToJump(cell);
      this.addTargetToJump(cell, "");
    },
    addPortToJump(cell) {
      const port = this.graph.insertVertex(
        cell,
        null,
        JSON.stringify({ elementType: "topPort", name: "" }),
        0.5,
        0,
        10,
        10,
        "topPort",
        true
      );

      port.geometry.offset = new mxPoint(-5, -10);

      return { inPort: port };
    },
    addTargetToJump(cell, target) {
      const targetCell = this.graph.insertVertex(
        cell,
        null,
        JSON.stringify({
          elementType: "jumpTarget",
          value: target,
        }),
        1,
        0.5,
        10,
        10,
        "jumpTarget",
        true
      );
      targetCell.setConnectable(false);
      targetCell.geometry.offset = new mxPoint(0, -5);
    },
    saveJumpToXml(cells, edgeCells) {
      const jumpCells = filter(cells, (cell) =>
        this.hasElementType(cell.value, "jump")
      );

      return {
        jumpStep: map(jumpCells, (jumpCell) => {
          const jumpObj = JSON.parse(jumpCell.value);

          const topPortCell = find(
            cells,
            (cell) => cell.style === "topPort" && cell.parent.id === jumpCell.id
          );
          const { cell: sourceCell, port: sourcePort } = this.findSource(
            cells,
            edgeCells,
            topPortCell?.id
          );
          const connectionPointIn = {
            relPosition: {
              "@x": 0,
              "@y": jumpCell.geometry.height * topPortCell?.geometry.y,
            },
            connection: sourceCell?.id
              ? {
                  "@refLocalId": sourceCell?.id,
                  "@formalParameter": JSON.parse(sourcePort.value).name,
                }
              : undefined,
          };

          return {
            "@localId": jumpCell.id,
            "@height": jumpCell.geometry.height,
            "@width": jumpCell.geometry.width,
            "@targetName": jumpObj.target,
            position: {
              "@x": jumpCell.geometry.x,
              "@y": jumpCell.geometry.y,
            },
            connectionPointIn,
          };
        }),
      };
    },
    renderJumps(elements, oldIdsToNewIds, connections) {
      const jumpStepElements = filter(elements, { name: "jumpStep" });
      for (const jumpStepElement of jumpStepElements) {
        const positionElement = find(jumpStepElement.elements, {
          name: "position",
        });

        const cell = this.graph.insertVertex(
          this.parent,
          null,
          JSON.stringify({
            elementType: "jump",
            name: "Jump",
            target: jumpStepElement.attributes.targetName,
          }),
          +positionElement.attributes.x,
          +positionElement.attributes.y,
          +jumpStepElement.attributes.width,
          +jumpStepElement.attributes.height,
          "shape=jump"
        );
        this.addTargetToJump(cell, jumpStepElement.attributes.targetName);

        oldIdsToNewIds[jumpStepElement.attributes.localId] = cell.id;

        cell.setConnectable(false);
        const { inPort } = this.addPortToJump(cell);

        const connectionPointInElement = find(jumpStepElement.elements, {
          name: "connectionPointIn",
        });
        const connectionElement = find(connectionPointInElement.elements, {
          name: "connection",
        });
        if (connectionElement?.attributes?.refLocalId) {
          connections.push({
            sourceId: connectionElement.attributes.refLocalId,

            targetPortNewId: inPort.id,

            sourcePortName: connectionElement.attributes.formalParameter,
          });
        }
      }
    },

    renderDivergence(obj, x, y, w = 50) {
      const cell = this.graph.insertVertex(
        this.parent,
        null,
        JSON.stringify(obj),
        x,
        y,
        w,
        1
      );

      cell.setConnectable(false);

      switch (obj.type) {
        case "selectionDivergence": {
          cell.setStyle("shape=line");

          this.addPortToSelectionDivergence(
            cell,
            obj.numOfSequences,
            obj.portPosition
          );

          break;
        }
        case "selectionConvergence": {
          cell.setStyle("shape=line");

          this.addPortToSelectionConvergence(
            cell,
            obj.numOfSequences,
            obj.portPosition
          );

          break;
        }
        case "simultaneousDivergence": {
          cell.setStyle("shape=simultaneousDivergence");

          this.addPortToSimultaneousDivergence(
            cell,
            obj.numOfSequences,
            obj.portPosition
          );

          break;
        }
        case "simultaneousConvergence": {
          cell.setStyle("shape=simultaneousDivergence");

          this.addPortToSimultaneousConvergence(
            cell,
            obj.numOfSequences,
            obj.portPosition
          );

          break;
        }
      }
    },
    updateDivergence(cell, obj) {
      this.graph.removeCells(this.graph.getChildCells(cell));

      switch (obj.type) {
        case "selectionDivergence": {
          cell.setStyle("shape=line");

          this.addPortToSelectionDivergence(
            cell,
            obj.numOfSequences,
            obj.portPosition
          );

          break;
        }
        case "selectionConvergence": {
          cell.setStyle("shape=line");

          this.addPortToSelectionConvergence(
            cell,
            obj.numOfSequences,
            obj.portPosition
          );

          break;
        }
        case "simultaneousDivergence": {
          cell.setStyle("shape=simultaneousDivergence");

          this.addPortToSimultaneousDivergence(
            cell,
            obj.numOfSequences,
            obj.portPosition
          );

          break;
        }
        case "simultaneousConvergence": {
          cell.setStyle("shape=simultaneousDivergence");

          this.addPortToSimultaneousConvergence(
            cell,
            obj.numOfSequences,
            obj.portPosition
          );

          break;
        }
      }

      this.graph.model.setValue(cell, JSON.stringify(obj));
    },
    addPortToSelectionDivergence(cell, numOfSequences, portPosition) {
      const sequenceOffset = 1 / (numOfSequences - 1);
      let currentPos = 0;

      for (let i = 0; i < numOfSequences; i += 1) {
        const bottomPort = this.graph.insertVertex(
          cell,
          null,
          JSON.stringify({ elementType: "bottomPort", name: "" }),
          currentPos,
          0,
          10,
          10,
          "bottomPort",
          true
        );

        bottomPort.geometry.offset = new mxPoint(-5, 2);
        currentPos += sequenceOffset;
      }

      const topPort = this.graph.insertVertex(
        cell,
        null,
        JSON.stringify({ elementType: "topPort", name: "" }),
        portPosition * sequenceOffset + sequenceOffset / 2,
        0,
        10,
        10,
        "topPort",
        true
      );

      topPort.geometry.offset = new mxPoint(-5, -10);

      return { inPort: topPort };
    },
    addPortToSelectionConvergence(cell, numOfSequences, portPosition) {
      const sequenceOffset = 1 / (numOfSequences - 1);
      const inPorts = [];
      let currentPos = 0;

      for (let i = 0; i < numOfSequences; i += 1) {
        const topPort = this.graph.insertVertex(
          cell,
          null,
          JSON.stringify({ elementType: "topPort", name: "" }),
          currentPos,
          0,
          10,
          10,
          "topPort",
          true
        );

        topPort.geometry.offset = new mxPoint(-5, -10);
        currentPos += sequenceOffset;
        inPorts.push(topPort);
      }

      const bottomPort = this.graph.insertVertex(
        cell,
        null,
        JSON.stringify({ elementType: "bottomPort", name: "" }),
        portPosition * sequenceOffset + sequenceOffset / 2,
        0,
        10,
        10,
        "bottomPort",
        true
      );

      bottomPort.geometry.offset = new mxPoint(-5, 2);
      return { inPorts };
    },
    addPortToSimultaneousDivergence(cell, numOfSequences, portPosition) {
      const sequenceOffset = 1 / numOfSequences;
      let currentPos = sequenceOffset / 2;

      for (let i = 0; i < numOfSequences; i += 1) {
        const bottomPort = this.graph.insertVertex(
          cell,
          null,
          JSON.stringify({ elementType: "bottomPort", name: "" }),
          currentPos,
          1,
          10,
          10,
          "bottomPort",
          true
        );

        bottomPort.geometry.offset = new mxPoint(-5, 3);
        currentPos += sequenceOffset;
      }

      const topPort = this.graph.insertVertex(
        cell,
        null,
        JSON.stringify({ elementType: "topPort", name: "" }),
        portPosition * sequenceOffset + sequenceOffset,
        0,
        10,
        10,
        "topPort",
        true
      );

      topPort.geometry.offset = new mxPoint(-5, -10);
      return { inPort: topPort };
    },
    addPortToSimultaneousConvergence(cell, numOfSequences, portPosition) {
      const sequenceOffset = 1 / numOfSequences;
      let currentPos = sequenceOffset / 2;
      const inPorts = [];

      for (let i = 0; i < numOfSequences; i += 1) {
        const topPort = this.graph.insertVertex(
          cell,
          null,
          JSON.stringify({ elementType: "topPort", name: "" }),
          currentPos,
          0,
          10,
          10,
          "topPort",
          true
        );

        topPort.geometry.offset = new mxPoint(-5, -10);
        currentPos += sequenceOffset;
        inPorts.push(topPort);
      }

      const bottomPort = this.graph.insertVertex(
        cell,
        null,
        JSON.stringify({ elementType: "bottomPort", name: "" }),
        portPosition * sequenceOffset + sequenceOffset,
        1,
        10,
        10,
        "bottomPort",
        true
      );

      bottomPort.geometry.offset = new mxPoint(-5, 3);
      return { inPorts };
    },
    saveDivergence(cells, edgeCells) {
      return {
        ...this.saveSelectionDivergence(cells, edgeCells),
        ...this.saveSelectionConvergence(cells, edgeCells),
        ...this.saveSimultaneousDivergence(cells, edgeCells),
        ...this.saveSimultaneousConvergence(cells, edgeCells),
      };
    },
    saveSelectionDivergence(cells, edgeCells) {
      const selectionDivergenceCells = filter(
        cells,
        (cell) =>
          this.hasElementType(cell.value, "divergence") &&
          JSON.parse(cell.value).type === "selectionDivergence"
      );

      return {
        selectionDivergence: map(
          selectionDivergenceCells,
          (selectionDivergenceCell) => {
            const selectionDivergenceObj = JSON.parse(
              selectionDivergenceCell.value
            );

            const topPortCell = find(
              cells,
              (cell) =>
                cell.style === "topPort" &&
                cell.parent.id === selectionDivergenceCell.id
            );
            const { cell: sourceCell, port: sourcePort } = this.findSource(
              cells,
              edgeCells,
              topPortCell?.id
            );
            const connectionPointIn = {
              relPosition: {
                "@x":
                  selectionDivergenceCell.geometry.width *
                  topPortCell?.geometry?.x,
                "@y": 0,
              },
              connection: sourceCell?.id
                ? {
                    "@refLocalId": sourceCell?.id,
                    "@formalParameter": JSON.parse(sourcePort.value).name,
                  }
                : undefined,
            };

            const bottomPortCells = filter(
              cells,
              (cell) =>
                cell.style === "bottomPort" &&
                cell.parent.id === selectionDivergenceCell.id
            );
            const connectionPointOut = map(
              bottomPortCells,
              (bottomPortCell) => ({
                relPosition: {
                  "@x":
                    selectionDivergenceCell.geometry.width *
                    bottomPortCell.geometry.x,
                  "@y": selectionDivergenceCell.geometry.height,
                },
              })
            );

            return {
              "@localId": selectionDivergenceCell.id,
              "@height": selectionDivergenceCell.geometry.height,
              "@width": selectionDivergenceCell.geometry.width,
              position: {
                "@x": selectionDivergenceCell.geometry.x,
                "@y": selectionDivergenceCell.geometry.y,
              },
              connectionPointIn,
              connectionPointOut,
            };
          }
        ),
      };
    },
    saveSelectionConvergence(cells, edgeCells) {
      const selectionConvergenceCells = filter(
        cells,
        (cell) =>
          this.hasElementType(cell.value, "divergence") &&
          JSON.parse(cell.value).type === "selectionConvergence"
      );

      return {
        selectionConvergence: map(
          selectionConvergenceCells,
          (selectionConvergenceCell) => {
            const selectionConvergenceObj = JSON.parse(
              selectionConvergenceCell.value
            );

            const topPortCells = filter(
              cells,
              (cell) =>
                cell.style === "topPort" &&
                cell.parent.id === selectionConvergenceCell.id
            );
            const connectionPointIn = map(topPortCells, (topPortCell) => {
              const sourceCell = this.findSource(
                cells,
                edgeCells,
                topPortCell.id
              );

              return {
                relPosition: {
                  "@x":
                    selectionConvergenceCell.geometry.width *
                    topPortCell.geometry.x,
                  "@y": 0,
                },
                connection: sourceCell?.id
                  ? {
                      "@refLocalId": sourceCell?.id,
                    }
                  : undefined,
              };
            });

            const bottomPortCell = find(
              cells,
              (cell) =>
                cell.style === "bottomPort" &&
                cell.parent.id === selectionConvergenceCell.id
            );
            const connectionPointOut = {
              relPosition: {
                "@x":
                  selectionConvergenceCell.geometry.width *
                  bottomPortCell?.geometry.x,
                "@y": selectionConvergenceCell.geometry.height,
              },
            };

            return {
              "@localId": selectionConvergenceCell.id,
              "@height": selectionConvergenceCell.geometry.height,
              "@width": selectionConvergenceCell.geometry.width,
              position: {
                "@x": selectionConvergenceCell.geometry.x,
                "@y": selectionConvergenceCell.geometry.y,
              },
              connectionPointIn,
              connectionPointOut,
            };
          }
        ),
      };
    },
    saveSimultaneousDivergence(cells, edgeCells) {
      const simultaneousDivergenceCells = filter(
        cells,
        (cell) =>
          this.hasElementType(cell.value, "divergence") &&
          JSON.parse(cell.value).type === "simultaneousDivergence"
      );

      return {
        simultaneousDivergence: map(
          simultaneousDivergenceCells,
          (simultaneousDivergenceCell) => {
            const simultaneousDivergenceObj = JSON.parse(
              simultaneousDivergenceCell.value
            );

            const topPortCell = find(
              cells,
              (cell) =>
                cell.style === "topPort" &&
                cell.parent.id === simultaneousDivergenceCell.id
            );
            const sourceCell = this.findSource(
              cells,
              edgeCells,
              topPortCell?.id
            );
            const connectionPointIn = {
              relPosition: {
                "@x":
                  simultaneousDivergenceCell.geometry.width *
                  topPortCell?.geometry.x,
                "@y": 0,
              },
              connection: sourceCell?.id
                ? {
                    "@refLocalId": sourceCell?.id,
                  }
                : undefined,
            };

            const bottomPortCells = filter(
              cells,
              (cell) =>
                cell.style === "bottomPort" &&
                cell.parent.id === simultaneousDivergenceCell.id
            );
            const connectionPointOut = map(
              bottomPortCells,
              (bottomPortCell) => ({
                relPosition: {
                  "@x":
                    simultaneousDivergenceCell.geometry.width *
                    bottomPortCell.geometry.x,
                  "@y": simultaneousDivergenceCell.geometry.height,
                },
              })
            );

            return {
              "@localId": simultaneousDivergenceCell.id,
              "@height": simultaneousDivergenceCell.geometry.height,
              "@width": simultaneousDivergenceCell.geometry.width,
              position: {
                "@x": simultaneousDivergenceCell.geometry.x,
                "@y": simultaneousDivergenceCell.geometry.y,
              },
              connectionPointIn,
              connectionPointOut,
            };
          }
        ),
      };
    },
    saveSimultaneousConvergence(cells, edgeCells) {
      const simultaneousConvergenceCells = filter(
        cells,
        (cell) =>
          this.hasElementType(cell.value, "divergence") &&
          JSON.parse(cell.value).type === "simultaneousConvergence"
      );

      return {
        simultaneousConvergence: map(
          simultaneousConvergenceCells,
          (simultaneousConvergenceCell) => {
            const simultaneousConvergenceObj = JSON.parse(
              simultaneousConvergenceCell.value
            );

            const topPortCells = filter(
              cells,
              (cell) =>
                cell.style === "topPort" &&
                cell.parent.id === simultaneousConvergenceCell.id
            );
            const connectionPointIn = map(topPortCells, (topPortCell) => {
              const sourceCell = this.findSource(
                cells,
                edgeCells,
                topPortCell.id
              );

              return {
                relPosition: {
                  "@x":
                    simultaneousConvergenceCell.geometry.width *
                    topPortCell.geometry.x,
                  "@y": 0,
                },
                connection: sourceCell?.id
                  ? {
                      "@refLocalId": sourceCell?.id,
                    }
                  : undefined,
              };
            });

            const bottomPortCell = find(
              cells,
              (cell) =>
                cell.style === "bottomPort" &&
                cell.parent.id === simultaneousConvergenceCell.id
            );
            const connectionPointOut = {
              relPosition: {
                "@x":
                  simultaneousConvergenceCell.geometry.width *
                  bottomPortCell?.geometry.x,
                "@y": simultaneousConvergenceCell.geometry.height,
              },
            };

            return {
              "@localId": simultaneousConvergenceCell.id,
              "@height": simultaneousConvergenceCell.geometry.height,
              "@width": simultaneousConvergenceCell.geometry.width,
              position: {
                "@x": simultaneousConvergenceCell.geometry.x,
                "@y": simultaneousConvergenceCell.geometry.y,
              },
              connectionPointIn,
              connectionPointOut,
            };
          }
        ),
      };
    },
    renderDivergences(elements, oldIdsToNewIds, connections) {
      this.renderSelectionDivergences(elements, oldIdsToNewIds, connections);
      this.renderSelectionConvergences(elements, oldIdsToNewIds, connections);
      this.renderSimultaneousConvergences(
        elements,
        oldIdsToNewIds,
        connections
      );
      this.renderSimultaneousConvergences(
        elements,
        oldIdsToNewIds,
        connections
      );
    },
    renderSelectionDivergences(elements, oldIdsToNewIds, connections) {
      const selectionDivergenceElements = filter(elements, {
        name: "selectionDivergence",
      });
      for (const selectionDivergenceElement of selectionDivergenceElements) {
        const positionElement = find(selectionDivergenceElement.elements, {
          name: "position",
        });
        const {
          portPosition,
          numOfSequences,
        } = this.getDivergenceNumOfSequencesAndPortPositionFromXmlObj(
          selectionDivergenceElement.elements
        );
        const cell = this.graph.insertVertex(
          this.parent,
          null,
          JSON.stringify({
            elementType: "divergence",
            name: "Divergence",
            type: "selectionDivergence",
            numOfSequences,
            portPosition,
          }),
          +positionElement.attributes.x,
          +positionElement.attributes.y,
          +selectionDivergenceElement.attributes.width,
          +selectionDivergenceElement.attributes.height,
          "shape=line"
        );

        oldIdsToNewIds[selectionDivergenceElement.attributes.localId] = cell.id;

        cell.setConnectable(false);
        const { inPort } = this.addPortToSelectionDivergence(
          cell,
          numOfSequences,
          portPosition
        );

        const connectionPointInElement = find(
          selectionDivergenceElement.elements,
          {
            name: "connectionPointIn",
          }
        );
        if (connectionPointInElement) {
          const connectionElement = find(connectionPointInElement.elements, {
            name: "connection",
          });
          if (connectionElement?.attributes?.refLocalId) {
            connections.push({
              sourceId: connectionElement.attributes.refLocalId,

              targetPortNewId: inPort.id,

              sourcePortName: connectionElement.attributes.formalParameter,
            });
          }
        }
      }
    },
    renderSelectionConvergences(elements, oldIdsToNewIds, connections) {
      const selectionConvergenceElements = filter(elements, {
        name: "selectionConvergence",
      });
      for (const selectionConvergenceElement of selectionConvergenceElements) {
        const positionElement = find(selectionConvergenceElement.elements, {
          name: "position",
        });
        const {
          portPosition,
          numOfSequences,
        } = this.getConvergenceNumOfSequencesAndPortPositionFromXmlObj(
          selectionConvergenceElement.elements
        );
        const cell = this.graph.insertVertex(
          this.parent,
          null,
          JSON.stringify({
            elementType: "divergence",
            name: "Divergence",
            type: "selectionConvergence",
            numOfSequences,
            portPosition,
          }),
          +positionElement.attributes.x,
          +positionElement.attributes.y,
          +selectionConvergenceElement.attributes.width,
          +selectionConvergenceElement.attributes.height,
          "shape=line"
        );

        oldIdsToNewIds[selectionConvergenceElement.attributes.localId] =
          cell.id;

        cell.setConnectable(false);
        const { inPorts } = this.addPortToSelectionConvergence(
          cell,
          numOfSequences,
          portPosition
        );

        const connectionPointInElements = filter(
          selectionConvergenceElement.elements,
          {
            name: "connectionPointIn",
          }
        );
        for (let i = 0; i < connectionPointInElements.length; i += 1) {
          const connectionElement = find(
            connectionPointInElements[i].elements,
            {
              name: "connection",
            }
          );
          if (connectionElement?.attributes?.refLocalId) {
            connections.push({
              sourceId: connectionElement.attributes.refLocalId,

              targetPortNewId: inPorts[i].id,

              sourcePortName: connectionElement.attributes.formalParameter,
            });
          }
        }
      }
    },
    renderSimultaneousDivergences(elements, oldIdsToNewIds, connections) {
      const simultaneousDivergenceElements = filter(elements, {
        name: "simultaneousDivergence",
      });
      for (const selectionDivergenceElement of simultaneousDivergenceElements) {
        const positionElement = find(simultaneousDivergenceElement.elements, {
          name: "position",
        });
        const {
          portPosition,
          numOfSequences,
        } = this.getDivergenceNumOfSequencesAndPortPositionFromXmlObj(
          simultaneousDivergenceElement.elements
        );
        const cell = this.graph.insertVertex(
          this.parent,
          null,
          JSON.stringify({
            elementType: "divergence",
            name: "Divergence",
            type: "simultaneousDivergence",
            numOfSequences,
            portPosition,
          }),
          +positionElement.attributes.x,
          +positionElement.attributes.y,
          +simultaneousDivergenceElement.attributes.width,
          +simultaneousDivergenceElement.attributes.height,
          "shape=simultaneousDivergence"
        );

        oldIdsToNewIds[simultaneousDivergenceElement.attributes.localId] =
          cell.id;

        cell.setConnectable(false);
        const { inPort } = this.addPortToSimultaneousDivergence(
          cell,
          numOfSequences,
          portPosition
        );

        const connectionPointInElement = find(
          simultaneousDivergenceElement.elements,
          {
            name: "connectionPointIn",
          }
        );
        if (connectionPointInElement) {
          const connectionElement = find(connectionPointInElement.elements, {
            name: "connection",
          });
          if (connectionElement?.attributes?.refLocalId) {
            connections.push({
              sourceId: connectionElement.attributes.refLocalId,

              targetPortNewId: inPort.id,

              sourcePortName: connectionElement.attributes.formalParameter,
            });
          }
        }
      }
    },
    renderSimultaneousConvergences(elements, oldIdsToNewIds, connections) {
      const simultaneousConvergenceElements = filter(elements, {
        name: "simultaneousConvergence",
      });
      for (const simultaneousConvergenceElement of simultaneousConvergenceElements) {
        const positionElement = find(simultaneousConvergenceElement.elements, {
          name: "position",
        });
        const {
          portPosition,
          numOfSequences,
        } = this.getConvergenceNumOfSequencesAndPortPositionFromXmlObj(
          simultaneousConvergenceElement.elements
        );
        const cell = this.graph.insertVertex(
          this.parent,
          null,
          JSON.stringify({
            elementType: "divergence",
            name: "Divergence",
            type: "simultaneousConvergence",
            numOfSequences,
            portPosition,
          }),
          +positionElement.attributes.x,
          +positionElement.attributes.y,
          +simultaneousConvergenceElement.attributes.width,
          +simultaneousConvergenceElement.attributes.height,
          "shape=simultaneousDivergence"
        );

        oldIdsToNewIds[simultaneousConvergenceElement.attributes.localId] =
          cell.id;

        cell.setConnectable(false);
        const { inPorts } = this.addPortToSimultaneousConvergence(
          cell,
          numOfSequences,
          portPosition
        );

        const connectionPointInElements = filter(
          simultaneousConvergenceElement.elements,
          {
            name: "connectionPointIn",
          }
        );
        for (let i = 0; i < connectionPointInElements.length; i += 1) {
          const connectionElement = find(
            connectionPointInElements[i].elements,
            {
              name: "connection",
            }
          );
          if (connectionElement?.attributes?.refLocalId) {
            connections.push({
              sourceId: connectionElement.attributes.refLocalId,

              targetPortNewId: inPorts[i].id,

              sourcePortName: connectionElement.attributes.formalParameter,
            });
          }
        }
      }
    },
    getDivergenceNumOfSequencesAndPortPositionFromXmlObj(elements) {
      const connectionPointInElement = find(
        elements,
        (element) => element.name === "connectionPointIn"
      );
      const connectionPointOutElements = filter(
        elements,
        (element) => element.name === "connectionPointOut"
      );
      let portPosition = 0;

      for (let i = 0; i < connectionPointOutElements.length; i += 1) {
        if (
          connectionPointInElement.elements[0].attributes.x >
          connectionPointOutElements[i].elements[0].attributes.x
        ) {
          portPosition = i;
        } else {
          break;
        }
      }

      return {
        portPosition,
        numOfSequences: connectionPointOutElements.length,
      };
    },
    getConvergenceNumOfSequencesAndPortPositionFromXmlObj(elements) {
      const connectionPointInElements = filter(
        elements,
        (element) => element.name === "connectionPointIn"
      );
      const connectionPointOutElement = find(
        elements,
        (element) => element.name === "connectionPointOut"
      );
      let portPosition = 0;

      for (let i = 0; i < connectionPointInElements.length; i += 1) {
        if (
          connectionPointOutElement.elements[0].attributes.x >
          connectionPointInElements[i].elements[0].attributes.x
        ) {
          portPosition = i;
        } else {
          break;
        }
      }

      return {
        portPosition,
        numOfSequences: connectionPointInElements.length,
      };
    },

    renderAction(sfcElement, x, y) {
      const cell = this.graph.insertVertex(
        this.parent,
        null,
        JSON.stringify(sfcElement),
        x,
        y,
        100,
        100,
        null
      );
      cell.setConnectable(false);
      this.addPortToAction(cell);
    },
    addPortToAction(cell) {
      const port = this.graph.insertVertex(
        cell,
        null,
        JSON.stringify({ elementType: "leftPort", name: "" }),
        0,
        0.2,
        10,
        10,
        "leftPort",
        true
      );

      port.geometry.offset = new mxPoint(-10, 0);

      return { inPort: port };
    },
    saveActionToXml(cells, edgeCells) {
      const actionCells = filter(cells, (cell) =>
        this.hasElementType(cell.value, "action")
      );

      return {
        actionBlock: map(actionCells, (actionCell) => {
          const actionObj = JSON.parse(actionCell.value);

          const leftPortCell = find(
            cells,
            (cell) =>
              cell.style === "leftPort" && cell.parent.id === actionCell.id
          );
          const { cell: sourceCell, port: sourcePort } = this.findSource(
            cells,
            edgeCells,
            leftPortCell?.id
          );
          const connectionPointIn = {
            relPosition: {
              "@x": 0,
              "@y": actionCell.geometry.height * leftPortCell?.geometry.y,
            },
            connection: sourceCell?.id
              ? {
                  "@refLocalId": sourceCell?.id,
                  "@formalParameter": JSON.parse(sourcePort.value).name,
                }
              : undefined,
          };

          const actions = map(actionObj.actions, (action, index) => {
            return {
              relPosition: {
                "@x": 0,
                "@y":
                  (actionCell.geometry.height / actionObj.actions.length) *
                  index,
              },
              reference: {
                "@name": "",
              },
              inline:
                action.type === "inline"
                  ? {
                      "xhtml:p": {
                        $: action.value,
                      },
                    }
                  : undefined,
              "@localId": "0",
              "@qualifier": action.qualifier,
              "@duration": action.duration,
              "@indicator": action.indicator,
            };
          });

          return {
            "@localId": actionCell.id,
            "@height": actionCell.geometry.height,
            "@width": actionCell.geometry.width,
            position: {
              "@x": actionCell.geometry.x,
              "@y": actionCell.geometry.y,
            },
            connectionPointIn,
            action: actions,
          };
        }),
      };
    },
    renderActions(elements, oldIdsToNewIds, connections) {
      const actionBlockElements = filter(elements, { name: "actionBlock" });
      for (const actionBlockElement of actionBlockElements) {
        const positionElement = find(actionBlockElement.elements, {
          name: "position",
        });

        const actionElements = filter(actionBlockElement.elements, {
          name: "action",
        });
        const actions = map(actionElements, (actionElement) => {
          const actionObj = {
            tempId: this.uuid(),
            qualifier: actionElement.attributes.qualifier,
            duration: actionElement.attributes.duration,
            indicator: actionElement.attributes.indicator,
          };

          const inlineElement = find(actionElement.elements, {
            name: "inline",
          });
          const referenceElement = find(actionElement.elements, {
            name: "reference",
          });

          if (inlineElement) {
            assign(actionObj, {
              type: "inline",
              value: inlineElement.elements[0].elements[0].cdata,
            });
          } else if (referenceElement) {
            assign(actionObj, {
              type: "reference",
              value: "",
            });
          }

          return actionObj;
        });

        const cell = this.graph.insertVertex(
          this.parent,
          null,
          JSON.stringify({
            elementType: "action",
            name: "Action",
            actions,
          }),
          +positionElement.attributes.x,
          +positionElement.attributes.y,
          +actionBlockElement.attributes.width,
          +actionBlockElement.attributes.height
        );

        oldIdsToNewIds[actionBlockElement.attributes.localId] = cell.id;

        cell.setConnectable(false);
        const { inPort } = this.addPortToAction(cell);

        const connectionPointInElement = find(actionBlockElement.elements, {
          name: "connectionPointIn",
        });
        const connectionElement = find(connectionPointInElement.elements, {
          name: "connection",
        });
        if (connectionElement?.attributes?.refLocalId) {
          connections.push({
            sourceId: connectionElement.attributes.refLocalId,

            targetPortNewId: inPort.id,

            sourcePortName: connectionElement.attributes.formalParameter,
          });
        }
      }
    },

    saveSfcObjs(cells, edgeCells) {
      const stepCells = filter(
        cells,
        (cell) =>
          this.hasElementType(cell.value, "step") ||
          this.hasElementType(cell.value, "initialStep")
      );

      const transitionCells = filter(cells, (cell) =>
        this.hasElementType(cell.value, "transition")
      );

      // const selectionDivergenceCells = filter(
      //   cells,
      //   (cell) =>
      //     this.hasElementType(cell.value, "divergence") &&
      //     JSON.parse(cell.value).type === "selectionDivergence"
      // );

      const sfcObj = {
        step: map(stepCells, (stepCell) => {
          const stepObj = JSON.parse(stepCell.value);

          const topPortCell = find(
            cells,
            (cell) => cell.style === "topPort" && cell.parent.id === stepCell.id
          );

          const rightPortCell = find(
            cells,
            (cell) =>
              cell.style === "rightPort" && cell.parent.id === stepCell.id
          );

          const bottomPortCell = find(
            cells,
            (cell) =>
              cell.style === "bottomPort" && cell.parent.id === stepCell.id
          );

          let connectionPointOutAction;

          if (rightPortCell) {
            connectionPointOutAction = {
              "@formalParameter": "",
              relPosition: {
                "@x": stepCell.geometry.width,
                "@y": stepCell.geometry.height / 2,
              },
            };
          }

          let connectionPointOut;

          if (bottomPortCell) {
            connectionPointOut = {
              "@formalParameter": "",
              relPosition: {
                "@x": stepCell.geometry.width / 2,
                "@y": stepCell.geometry.height,
              },
            };
          }

          let connectionPointIn;

          if (topPortCell) {
            const { cell: sourceCell } = this.findSource(
              cells,
              edgeCells,
              topPortCell.id
            );

            connectionPointIn = {
              relPosition: {
                "@x": stepCell.geometry.width / 2,
                "@y": 0,
              },
              connection: {
                "@refLocalId": sourceCell?.id,
              },
            };
          }

          return {
            "@localId": stepCell.id,
            "@name": stepObj.name,
            "@initialStep": stepObj.elementType === "step" ? "false" : "true",
            "@height": stepCell.geometry.height,
            "@width": stepCell.geometry.width,
            position: {
              "@x": stepCell.geometry.x,
              "@y": stepCell.geometry.y,
            },
            connectionPointIn,
            connectionPointOut,
            connectionPointOutAction,
          };
        }),
        transition: map(transitionCells, (transitionCell) => {
          const transitionObj = JSON.parse(transitionCell.value);

          const topPortCell = find(
            cells,
            (cell) =>
              cell.style === "topPort" && cell.parent.id === transitionCell.id
          );

          const leftPortCell = find(
            cells,
            (cell) =>
              cell.style === "leftPort" && cell.parent.id === transitionCell.id
          );

          let condition;

          if (leftPortCell) {
            const { cell: leftSourceCell } = this.findSource(
              cells,
              edgeCells,
              leftPortCell.id
            );

            condition = {
              connectionPointIn: {
                "@formalParameter": leftSourceCell
                  ? leftSourceCell.value || ""
                  : "",
                relPosition: {
                  "@x": transitionCell.geometry.width,
                  "@y": transitionCell.geometry.height / 2,
                },
              },
            };
          } else if (transitionObj.type === "inline") {
            condition = {
              inline: {
                "@name": "",
                ST: {
                  "xhtml:p": {
                    $: transitionObj.inline,
                  },
                },
              },
            };
          } else if (transitionObj.type === "reference") {
            condition = {
              reference: {},
            };
          }

          const connectionPointOut = {
            relPosition: {
              "@x": transitionCell.geometry.width / 2,
              "@y": transitionCell.geometry.height,
            },
          };

          const { cell: sourceCell } = this.findSource(
            cells,
            edgeCells,
            topPortCell?.id
          );

          const connectionPointIn = {
            relPosition: {
              "@x": transitionCell.geometry.width / 2,
              "@y": 0,
            },
            connection: {
              "@refLocalId": sourceCell?.id,
            },
          };

          return {
            "@localId": transitionCell.id,
            "@priority":
              +transitionObj.priority > 0
                ? `${transitionObj.priority}`
                : undefined,
            "@height": transitionCell.geometry.height,
            "@width": transitionCell.geometry.width,
            position: {
              "@x": transitionCell.geometry.x,
              "@y": transitionCell.geometry.y,
            },
            condition,
            connectionPointIn,
            connectionPointOut,
          };
        }),
        ...this.saveDivergence(cells, edgeCells),
        ...this.saveActionToXml(cells, edgeCells),
        ...this.saveJumpToXml(cells, edgeCells),
      };
      return sfcObj;
    },
    addConnectorToStep(cell, connectors) {
      let inPort, actionPort, outPort;

      if (connectors.includes("input")) {
        inPort = this.graph.insertVertex(
          cell,
          null,
          JSON.stringify({ name: "", elementType: "topPort" }),
          0.5,
          0,
          10,
          10,
          "topPort",
          true
        );

        inPort.geometry.offset = new mxPoint(-5, -10);
      }

      if (connectors.includes("action")) {
        actionPort = this.graph.insertVertex(
          cell,
          null,
          JSON.stringify({ name: "", elementType: "rightPort" }),
          1,
          0.5,
          10,
          10,
          "rightPort",
          true
        );

        actionPort.geometry.offset = new mxPoint(0, -5);
      }

      if (connectors.includes("output")) {
        outPort = this.graph.insertVertex(
          cell,
          null,
          JSON.stringify({ name: "", elementType: "bottomPort" }),
          0.5,
          1,
          10,
          10,
          "bottomPort",
          true
        );

        outPort.geometry.offset = new mxPoint(-5, 1);
      }

      return { inPort, actionPort, outPort };
    },
    addPriorityToTransition(cell, priority) {
      const priorityCell = this.graph.insertVertex(
        cell,
        null,
        JSON.stringify({
          elementType: "priority",
          value: priority,
        }),
        0,
        0,
        10,
        10,
        "priority",
        true
      );

      priorityCell.geometry.offset = new mxPoint(5, -10);
      priorityCell.setConnectable(false);
    },
    addLabelToTransition(cell, label) {
      try {
        this.graph.getModel().beginUpdate();

        const labelCell = this.graph.insertVertex(
          cell,
          null,
          JSON.stringify({
            elementType: "transitionLabel",
            value: label,
          }),
          1,
          0.5,
          10,
          15,
          "transitionLabel",
          true
        );

        labelCell.geometry.offset = new mxPoint(10, -15);
        labelCell.setConnectable(false);
      } finally {
        this.graph.getModel().endUpdate();
        this.graph.refresh();
      }
    },
    addPortToTransition(cell) {
      const topPort = this.graph.insertVertex(
        cell,
        null,
        JSON.stringify({
          elementType: "topPort",
          value: "",
        }),
        0.5,
        0,
        10,
        10,
        "topPort",
        true
      );

      topPort.geometry.offset = new mxPoint(-5, -9);

      const bottomPort = this.graph.insertVertex(
        cell,
        null,
        JSON.stringify({
          elementType: "bottomPort",
          value: "",
        }),
        0.5,
        1,
        10,
        10,
        "bottomPort",
        true
      );

      bottomPort.geometry.offset = new mxPoint(-5, 0);

      return { inPort: topPort };
    },
    addLeftPortToTransition(cell) {
      const leftPort = this.graph.insertVertex(
        cell,
        null,
        "",
        0,
        0.5,
        10,
        10,
        "shape=leftPort",
        true
      );

      leftPort.geometry.offset = new mxPoint(-9, -4);
    },

    configureSfcElements() {
      for (const sfcElement of sfcElements) {
        const sidebarItem = document.getElementById(
          `sfcEl_${sfcElement.elementType}`
        );
        if (!sidebarItem) {
          return;
        }

        const funct = (graph, evt, _, x, y) => {
          const parent = graph.getDefaultParent();
          const model = graph.getModel();

          let cell = null;

          try {
            model.beginUpdate();

            switch (sfcElement.elementType) {
              case "initialStep":
              case "step": {
                cell = graph.insertVertex(
                  parent,
                  null,
                  JSON.stringify(sfcElement),
                  x,
                  y,
                  100,
                  50,
                  sfcElement.elementType === "initialStep"
                    ? "shape=initialStep"
                    : undefined
                );

                cell.setConnectable(false);
                this.addConnectorToStep(cell, sfcElement.connectors);
                this.steps.push(sfcElement.name);
                break;
              }
              case "transition": {
                cell = graph.insertVertex(
                  parent,
                  null,
                  JSON.stringify(sfcElement),
                  x,
                  y,
                  30,
                  20,
                  `shape=transition`
                );
                cell.setConnectable(false);

                this.addPriorityToTransition(cell, sfcElement.priority);
                this.addLabelToTransition(cell, "");
                this.addPortToTransition(cell);
                break;
              }
              case "jump": {
                this.renderJump(sfcElement, x, y);
                break;
              }
              case "divergence": {
                this.renderDivergence(sfcElement, x, y);
                break;
              }
              case "action": {
                this.renderAction(sfcElement, x, y);
                break;
              }
            }
          } finally {
            model.endUpdate();
            graph.refresh();
          }
        };

        this.makeDragEl(sidebarItem, funct);
      }
    },

    
    saveAction() {
      if (this.editedAction.tempId) {
        const index = findIndex(this.editedObj.actions, {
          tempId: this.editedAction.tempId,
        });

        this.editedObj.actions.splice(index, 1, this.editedAction);
      } else {
        this.editedObj.actions.push({
          ...this.editedAction,
          tempId: this.uuid(),
        });
      }

      this.resetActionDialog();
    },
    editAction(value) {
      this.editedAction = value;
      this.actionDialog = true;
    },
    async deleteAction({ tempId }) {
      if (await this.$confirm("Are you sure you want to delete this action?")) {
        const index = findIndex(this.editedObj.actions, {
          tempId,
        });

        this.editedObj.actions.splice(index, 1);
      }
    },
    addAction() {
      this.editedAction = {};
    },
    resetActionDialog() {
      this.actionDialog = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.graph-container {
  flex-grow: 2;
  cursor: default;
  background: url("https://jgraph.github.io/mxgraph/javascript/examples/editors/images/grid.gif");
}
</style>
